export default class CollapsibleBox extends HTMLElement {
  private buttonEl: HTMLButtonElement | null = null;
  private contentEl: HTMLElement | null = null;

  constructor() {
    super();
  }

  onWindowResized() {
    const isExpanded = this.classList.contains('expanded');
    let targetHeight = 0;
    const rootStyle = getComputedStyle(this);

    if (this.contentEl?.scrollHeight) {
      targetHeight = this.contentEl.scrollHeight;
      targetHeight += parseFloat('12');
    }
    this.style.setProperty('--content-max-height', isExpanded ? `${targetHeight}px` : '0');
  }

  init() {
    this.buttonEl = this.querySelector('.collapsible-box-button:not(a)');
    this.contentEl = this.querySelector('.collapsible-box-content > .collapsible-box-content__children-wrapper');

    if (this.buttonEl && this.contentEl) {
      this.buttonEl.addEventListener('click', () => {
        const isExpanded = this.classList.contains('expanded');
        this.classList.toggle('expanded', !isExpanded);
        this.onWindowResized();
      });

      // Ouvre le dropdown s'il y a un enfant focusable
      const focusableChildren = this.contentEl.querySelectorAll<HTMLElement>('a, button, input, [tabindex]:not([tabindex="-1"])');

      focusableChildren.forEach((child) => {
        child.addEventListener('focusin', () => {
          const isExpanded = this.classList.contains('expanded');
          if (!isExpanded) {
            this.classList.add('expanded');
            this.onWindowResized();
          }
        });
      });

      const observer = new MutationObserver((mutationsList) => {
        this.onWindowResized();
      });

      observer.observe(this.contentEl, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      window.addEventListener('resize', () => {
        this.onWindowResized();
      });
    }

    this.onWindowResized();
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}